const getSelectedClass = (classes) => {
  const DEFAULT_CLASS = 'A'
  const urlParams = new URLSearchParams(window.location.search)
  const _paramClass = urlParams.get('class')

  const _selectedClass =
    classes.find(
      (fundClass) => fundClass.className === (_paramClass || DEFAULT_CLASS)
    ) || classes[0]

  return _selectedClass
}

export { getSelectedClass }
